import { MODULE } from "./searchFilter.actionTypes";

export const getSearch = (state) => state.getIn([MODULE, "search"]);

export default {};
